import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Chevron from "../../Icons/Chevron";
import Button from "../Button";

const propTypes = {
  page: PropTypes.number,
  total: PropTypes.number,
  setPage: PropTypes.func,
  controls: PropTypes.bool
};

const defaultProps = {
  page: 1,
  total: 0,
  controls: true,
  setPage: () => {}
};

const Pagination = ({ page, total, setPage, controls }) => (
  <Wrapper className="d-flex align-items-center gap-6">
    <small className="text-gray-80">
      {page || 1} of {total}
    </small>
    {controls && (
      <div className="buttons">
        <Button
          width={40}
          height={40}
          variant="secondary"
          className="px-0 w-100"
          onClick={() => page > 1 && setPage(page - 1)}
        >
          <Chevron
            direction="left"
            color={page > 1 ? "#000" : "var(--bs-gray-80)"}
          />
        </Button>
        <Button
          width={40}
          height={40}
          variant="secondary"
          className="px-0 w-100"
          onClick={() => page < total && setPage(page + 1)}
        >
          <Chevron
            direction="right"
            color={page < total ? "#000" : "var(--bs-gray-80)"}
          />
        </Button>
      </div>
    )}
  </Wrapper>
);

/**
 * styles
 */
const Wrapper = styled.div`
  .buttons {
    gap: 0.25rem;
    display: grid;
    grid-template-columns: repeat(2, 2.5rem);
  }
`;

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;

export default Pagination;
